import { getEntityFromScope } from '@bingads-webui/edm-campaign';
import {
  getFormattedDateString,
  MS_PER_DAY,
} from '../common/date';

export const fetchKeywords = ({
  count,
  scope,
}) => {
  const { currentAccount } = getEntityFromScope(scope);
  const endDate = new Date(Date.now());
  const formattedEndDate = getFormattedDateString(endDate);
  const msPer90Days = MS_PER_DAY * 90;
  const startDate = new Date(endDate.valueOf() - msPer90Days);
  const formattedStartDate = getFormattedDateString(startDate);

  return currentAccount.Keywords['Default.GridData'].findAll({
    select: [
      'Id',
      'Text',
      'Status',
      'PerformanceMetrics/Impressions',
    ],
    filter: {
      where: 'Status eq \'Active\'',
    },
    orderBy: [
      {
        key: 'PerformanceMetrics/Impressions',
        direction: 'DESC',
      },
    ],
    limit: count,
    query: {
      gridDataParameters: {
        DateRange: {
          StartDate: formattedStartDate,
          EndDate: formattedEndDate,
        },
      },
    },
  });
};
